import { IncidentType } from '../DTOs/Incident';

export function incidentTypeTextDa(type: IncidentType): string
{
    if (type === 'issue')
        return 'Hændelse';
    else if (type === 'almost-accident')
        return 'Nær-ved-ulykke';
    else if (type === 'whistleblower')
        return 'Whistleblower';
    else if (type === 'work-injury')
        return 'Arbejdsskade';

    const exhaustiveCheck: never = type;
    return exhaustiveCheck;
}